<div class="pa-units" [@.disabled]="reduceMotion">
  <button
    type="button"
    class="pa-units__radio"
    [class.pa-units__radio--on]="mode() === 'all'"
    (click)="pickAll()">
    <span class="pa-units__dot" aria-hidden="true"></span>
    <span class="pa-units__radio-label">
      <span class="pa-units__radio-text">{{ allUnitsLabel() }}</span>
      <span class="pa-units__radio-helper"
        >Plan includes every patient in the organization</span
      >
    </span>
  </button>

  <button
    type="button"
    class="pa-units__radio"
    [class.pa-units__radio--on]="mode() === 'specific'"
    (click)="pickSpecific()">
    <span class="pa-units__dot" aria-hidden="true"></span>
    <span class="pa-units__radio-label">
      <span class="pa-units__radio-text">Specific units</span>
      <span class="pa-units__radio-helper"
        >Pick the units you're responsible for</span
      >
    </span>
  </button>

  @if (mode() === 'specific') {
    <div class="pa-units__list" @listExpand>
      @for (unit of units(); track unit.id) {
        <label class="pa-units__check">
          <span
            class="pa-units__box"
            [class.pa-units__box--on]="isChecked(unit.id)"
            aria-hidden="true">
            @if (isChecked(unit.id)) {
              <i class="ph ph-check ph-bold"></i>
            }
          </span>
          <input
            type="checkbox"
            class="pa-units__native"
            [checked]="isChecked(unit.id)"
            (change)="toggleUnit(unit.id)" />
          {{ unit.name }}
        </label>
      }
    </div>
  }
</div>
